import React from 'react';
import { SERVICE_HEADER_TRIGGER_ID } from './constants';

// eslint-disable-next-line react/display-name
export default (props) => <div id={SERVICE_HEADER_TRIGGER_ID} {...props} />;
